<template>
    <KtvCard
        :description="$t('ktvThen.ktvPhoneNumber.description')"
        :title="$t('ktvThen.ktvPhoneNumber.title')"
    >
        <template #content>
            <DsInputField
                v-model="phoneNumber"
                :label="$t('ktvThen.ktvPhoneNumber.label')"
                readonly
                style="margin-bottom: 0;"
            />
        </template>
    </KtvCard>
</template>

<script>

import KtvCard from './KtvCard.vue';

export default {
    components: { KtvCard },

    props: {
        phoneNumber: {
            type: String,
            required: true,
        },
    },
};

</script>
